<template>
  <div class="contest_list_container">
    <!-- DEMO: RENDER LIST WITHOUT CONTESTANT IMAGES -->
    <div class=""
      v-for="contest in contests.contests"
      :key="contest.id">
        <contest-list-item-box 
        :contest="contest" 
        :contestants="contestants" 
        :vote_visible="false" 
        :contestant_images="false"
        ></contest-list-item-box>
    </div>

    <!-- DMEO: RENDER LIST WITH CONTESTANT IMAGES -->
    <div class=""
      v-for="contest in contests.contests"
      :key="contest.id">
        <contest-list-item-box 
        :contest="contest" 
        :contestants="contestants" 
        :vote_visible="false" 
        :contestant_images="true"
        ></contest-list-item-box>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import contest_list from '@/json/sample_contest_list.json';
import contestant_list from '@/json/sample_contestant_list.json';
import ContestListItemBox from '@/features/contests/contest_list_box.vue';

export default {
  name: 'ContestList',
  data () {
    return {
      contests: contest_list,
      contestants: contestant_list
    }
  },
  components: {
    ContestListItemBox
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '@/styles/global_styles.scss';

</style>


// WEBPACK FOOTER //
// src/features/contests/contest_list.vue